// extracted by mini-css-extract-plugin
export default {"content":"EditKitForm_content__x6gl3","checkbox":"EditKitForm_checkbox__5nqwU","buttons":"EditKitForm_buttons__bRpFW","placeHolderShimmer":"EditKitForm_placeHolderShimmer__rsvVq"};